export class CmpFauxDropDownOptionsObject {
    value: string | number = 0;
    secondValue: string | number = 0;
    status = false;
    name = '';
    optionDesc = '';
    optionSecondDesc = '';
    optionStatusDesc = '';
    optionStatus = '';
    statusColor = '';
    disabled = false;
}

export class CmpFauxMetaDropDownOptionsObject {
    value: string | number = 0;
    name = '';
    optionDesc = '';
    disabled = false;
    confirmationPrompt = '';
}

export class CmpFauxMetaDropDownObject {
    options: Array<CmpFauxMetaDropDownOptionsObject> = [];
    label: CmpFauxDropDownLabelObject = new CmpFauxDropDownLabelObject();
    disabled = false;
}

export class CmpFauxDropDownLabelObject {
    name = '';
    selectedLabel = '';
    defaultText = 'Attendee';
}

export class CmpFauxDropDownObject {
    options: Array<CmpFauxDropDownOptionsObject> = [];
    secondOption?: CmpFauxDropDownOptionsObject;
    label: CmpFauxDropDownLabelObject = new CmpFauxDropDownLabelObject();
    disabled = false;
    loading = false;
}
